export default "__VITE_ASSET__743ca7e7__"